import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';

export class CodeOceanUnPort extends TrackableEntity {
    id: number = 0;
    unCode: string = '';
    unCodeSub: string = '';
    unPortName: string = '';
    unCountry: string = '';
    unCountryName: string = '';
    unCityName: string = '';
    subDiv: string = '';
    usCode: string = '';

    // for only front-end
    edit: boolean = false;
    view: boolean = false;
    isNew: boolean = false;

    constructor(init?:Partial<CodeOceanUnPort>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id', 'unCodeSub');
        if(this.id === 0) this.id = this.GetNextId();
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        return CodeOceanUnPort.dicFieldMappings;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'unCode': new DBMappingInfo({ field: 'F_UnCode', table: 'T_CODEOCEANUNPORT' }),
        'unPortName': new DBMappingInfo({ field: 'F_UNPortName', table: 'T_CODEOCEANUNPORT' }),
        'unCountry': new DBMappingInfo({ field: 'F_UNCOUNTRY', table: 'T_CODEOCEANUNPORT' }),
        'usCode': new DBMappingInfo({ field: 'F_USCODE', table: 'T_CODEOCEANUNPORT' }),
        'subDiv': new DBMappingInfo({ field: 'F_SUBDIV', table: 'T_CODEOCEANUNPORT' }),
        'unCityName': new DBMappingInfo({ field: 'F_UNCityName', table: 'T_CODEOCEANUNPORT' }),
        'id': new DBMappingInfo({ field: 'F_Id', table: 'T_CODEOCEANUNPORT' }),

    };
}
